module.exports = __webpack_public_path__ + "img/big2.39dd944d.jpg";